<button (click)="clickFunction" class="btn-close" type="button" aria-label="close"></button>
